import { fetchHackcal, findNextEvent } from "./events";
import { setVisibleInterval } from "./visible-interval";

const POLL_INTERVAL_MS = 60_000;

async function updatePreview(el: HTMLElement): Promise<void> {
  try {
    const data = await fetchHackcal();
    const next = findNextEvent(data);

    const text = next
      ? `Nächster Termin: ${next.weekday}, ${next.datestr} – ${next.summary}`
      : "Aktuell keine Termine geplant";
    if (el.textContent !== text) el.textContent = text;
  } catch (err) {
    console.error("Konnte nächsten Termin nicht laden", err);
    // Keep whatever was last shown (initial static copy or a previous successful fetch)
    // rather than replacing it with an error state on a background refresh.
  }
}

/**
 * Renders the next event once, then keeps it fresh with a background poll so a
 * visitor who leaves the tab open doesn't see a stale date. Only re-fetches while
 * the tab is visible, and only touches the DOM when the text actually changed.
 */
export async function initNextEventPreview(): Promise<void> {
  const el = document.getElementById("nextEventPreview");
  if (!el) return;

  await updatePreview(el);

  setVisibleInterval(() => void updatePreview(el), POLL_INTERVAL_MS);
}
